/**
 * Detects "Maximum call stack size exceeded" errors that originate from
 * React's fiber reconciliation on mobile WebKit browsers (iOS Safari and
 * Chrome). These occur because iOS WebKit has much smaller call stack
 * limits than desktop browsers, and moderately deep React component trees
 * can exceed them during normal reconciliation. The errors are transient,
 * do not affect user experience, and are not actionable.
 *
 * Matches when:
 * 1. The error message is "Maximum call stack size exceeded"
 * 2. The stack trace consists entirely of minified React internal frames
 *    (no application code)
 */
export const isMobileStackOverflowNoise = (
  message: string | undefined,
  stack: string | undefined,
): boolean => {
  if (!message?.includes("Maximum call stack size exceeded")) {
    return false;
  }

  if (!stack) {
    return true;
  }

  const frames = stack
    .split("\n")
    .filter((line) => line.trim().startsWith("at "));

  if (frames.length === 0) {
    return true;
  }

  return frames.every((frame) => {
    const trimmed = frame.trim();
    return (
      trimmed.includes("@ undefined") ||
      trimmed === "at <anonymous> @ undefined"
    );
  });
};
